import React from 'react'

const Skills = () => {

  return (
    <>
    <div id='skillContainer' className='my-12 flex flex-wrap flex-col justify-center items-center '>
      <h1 className='text-3xl mb-3'>SKILLS</h1>
        <ul className='flex flex-wrap justify-center items-center'>
        <li className='skillLi'>HTML</li><li className='skillLi'>CSS</li><li className='skillLi'>Javascript</li><li className='skillLi'>React</li><li className='skillLi'>Redux</li><li className='skillLi'>Tailwind css</li><li className='skillLi'>JQuery</li><li className='skillLi'>Node js</li><li className='skillLi'>MongoDB</li><li className='skillLi'>GuitHub</li>
        </ul>
    </div>
    <hr className='block mx-auto h-1 bg-slate-800 w-3/4 my-3' />
    </>
  )
}

export default Skills